import fetchServer from "../../../fetchServer";

export default async function checkRefundStatus(id) {
  var result = { return: 0, msg: "Failed fetching request", data: [], code: null };

  await fetchServer({
    method: "GET",
    url: `/product/v1/refund/checkRefund/${id}`,
  })
    .then((res) => {
      if (!res) return;
      const payload = res.data ?? res;
      const nested =
        payload?.data && typeof payload.data === "object"
          ? payload.data
          : payload;
      const httpOk = res.status >= 200 && res.status < 300;

      if (httpOk) {
        result = {
          return: 1,
          msg: payload?.message || "Successfull",
          data: payload?.data ?? payload,
          code: null,
        };
      } else {
        result = {
          return: 0,
          msg:
            nested?.error ||
            payload?.error ||
            payload?.message ||
            result.msg,
          data: nested || [],
          code: nested?.code ?? payload?.code ?? null,
        };
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}